import 'css-chunksrc/client/scenes/event/details/styles.scss';export default {
  "details": "_details_1dq42_1",
  "name": "_name_1dq42_5",
  "eventCompletion": "_eventCompletion_1dq42_15",
  "input": "_input_1dq42_22",
  "description": "_description_1dq42_32",
  "label": "_label_1dq42_36",
  "paragraph": "_paragraph_1dq42_42",
  "advancement": "_advancement_1dq42_52",
  "percentage": "_percentage_1dq42_59",
  "progressBar": "_progressBar_1dq42_68",
  "percentageText": "_percentageText_1dq42_73",
  "advancementLabel": "_advancementLabel_1dq42_79",
  "descriptionMaxChars": "_descriptionMaxChars_1dq42_86",
  "loader": "_loader_1dq42_91",
  "loaderMain": "_loaderMain_1dq42_99"
};